import axios from 'axios';
import { buildApiUrl } from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';
import { mapTimezoneOptionsFromApiModel } from './dataMapper/timezineDataMapper';

const knownErrorsMap = {
  // @todo clarify this value with backend @feshchenko
  Empty: `We could not find our list of timezones.  Please refresh the page and try again. 
  If you continue to see this error, contact Nextiva Support.`,
};

export default () =>
  axios
    .get(buildApiUrl('timezone_offsets'))
    .catch(generateApiError({ knownErrorsMap }))
    .then(({ data }) => mapTimezoneOptionsFromApiModel(data));
